@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.modal-content-body-top-section {
  display: flex;
  height: 150px;
  width: 100%;
  margin: @space-4 @space-12 @space-12;
  justify-content: space-between;

  @media @mobile, @tablet {
    flex-direction: column;
    height: auto;
  }
}

.modal-content-top-right,
.modal-content-top-left {
  width: 50%;

  @media @mobile, @tablet {
    width: 100%;
  }
}

.row-spacing {
  align-items: center;
  margin: 10px;
  font-size: 13px;
}

.field {
  text-align: right;
  min-width: 100px;
  font-weight: 600;
  white-space: nowrap;
}

.top-right-field {
  text-align: right;
  min-width: 140px;
  font-weight: 600;
  white-space: nowrap;
}

.customer-info-field-value {
  padding: 0 15px;
}

.customer-info-field-value-marketplace {
  display: flex;
  width: 300px;
  overflow: auto;
  max-height: 50px;
  padding: 0 15px;
}

.dropdown-menu-toggler {
  border: 1px solid;
  padding: 0 10px;
  margin: 0;
  width: 170px;
  border-radius: 5px;
}

.all-marketplaces-link {
  font-size: 13px;
  white-space: nowrap;
}

.customer-marketplace-username-wrapper {
  width: 100%;
}
